import type { ParticipanteDetalhe } from "@/modules/escala/services/escalaService";

interface ResumoRespostasProps {
  participantes: ParticipanteDetalhe[];
}

/**
 * Barra e contagem de confirmadas/pendentes/recusadas. Só faz sentido (e só
 * aparece) quando o banco liberou o status de TODOS os participantes a quem
 * consulta — para o membro comum os colegas chegam sem status (γ, ESC-DEC-006)
 * e uma contagem parcial seria enganosa.
 */
export function ResumoRespostas({ participantes }: ResumoRespostasProps) {
  const todosVisiveis = participantes.length > 0 && participantes.every((p) => p.respostaVisivel && p.resposta);
  if (!todosVisiveis) return null;

  const confirmadas = participantes.filter((p) => p.resposta === "CONFIRMADA").length;
  const pendentes = participantes.filter((p) => p.resposta === "PENDENTE").length;
  const recusadas = participantes.filter((p) => p.resposta === "RECUSADA").length;

  return (
    <div className="flex flex-col gap-2.5 rounded-2xl border border-border bg-surface p-3.5">
      <div
        role="img"
        aria-label={`${confirmadas} confirmadas, ${pendentes} pendentes, ${recusadas} recusadas`}
        className="flex h-2.5 gap-0.5 overflow-hidden rounded-full bg-surface-2"
      >
        {confirmadas > 0 && <span className="bg-success" style={{ flex: confirmadas }} />}
        {pendentes > 0 && <span className="bg-warning" style={{ flex: pendentes }} />}
        {recusadas > 0 && <span className="bg-danger" style={{ flex: recusadas }} />}
      </div>
      <p className="flex flex-wrap gap-x-4 gap-y-1 text-[13px] text-text">
        <span className="inline-flex items-center gap-1.5">
          <span aria-hidden className="h-2.5 w-2.5 rounded-full bg-success" />
          <b>{confirmadas}</b> {confirmadas === 1 ? "confirmada" : "confirmadas"}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <span aria-hidden className="h-2.5 w-2.5 rounded-full bg-warning" />
          <b>{pendentes}</b> {pendentes === 1 ? "pendente" : "pendentes"}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <span aria-hidden className="h-2.5 w-2.5 rounded-full bg-danger" />
          <b>{recusadas}</b> {recusadas === 1 ? "recusada" : "recusadas"}
        </span>
      </p>
    </div>
  );
}
